import createReactClass from 'create-react-class';
import React from 'react';

import i18n from 'scripts/i18n/i18n';

const ContextEvent = createReactClass({
  render() {
    let contextEvent = this.props.contextEvent;

    return (
      <li className="contextContent-event">
        <i className="contextContent-event-circle fa fa-circle" />
        <div className="contextContent-event-details">
          <div className="contextContent-event-primaryDetail">{formatEventPrimaryDetail(contextEvent)}</div>
          <div className="contextContent-event-secondaryDetail">{formatEventSecondaryDetail(contextEvent)}</div>
        </div>
      </li>
    );
  },
});

// this is temporary until we finalize the context event structure and output templates
function formatEventPrimaryDetail(contextEvent) {
  let key = `${contextEvent.type}:${contextEvent.action}`;

  switch (key) {
    case 'reservation:search':
      return i18n.t(
        'Searching for reservation at {{property}} for a {{roomType}} Check-In: {{checkIn}} Check-Out: {{checkOut}}',
        {
          property: contextEvent.value.property,
          roomType: contextEvent.value.roomType,
          checkIn: contextEvent.value.checkIn,
          checkOut: contextEvent.value.checkOut,
        }
      );

    case 'policy:search':
      return i18n.t('Searching for policy: {{property}}', { property: contextEvent.value.property });

    case 'contact:voice':
      return i18n.t('Called customer support from {{phoneNumber}}', { phoneNumber: contextEvent.value.phoneNumber });

    case 'knowledge-base:search':
      return i18n.t('Searched knowledge base for: "{{searchText}}"', { searchText: contextEvent.value.searchText });

    case 'help-app:open':
      return i18n.t('Opened the help app on {{url}}', { url: contextEvent.value.url });
    case 'help-app:search':
      return i18n.t('Searched for "{{searchText}}"', { searchText: contextEvent.value.searchText });
    case 'help-app:view':
      return i18n.t('Viewed "{{answerTitle}}"', { answerTitle: contextEvent.value.answerTitle });
    case 'help-app:request':
      return i18n.t('Requested to chat with an agent');

    default:
      return JSON.stringify(contextEvent.value);
  }
}

function formatEventSecondaryDetail(contextEvent) {
  let key = `${contextEvent.type}:${contextEvent.action}`;

  switch (key) {
    case 'knowledge-base:search':
      return i18n.t('Number of returned results was: {{searchResults}}', {
        searchResults: contextEvent.value.searchResults,
      });
    case 'help-app:view':
      return contextEvent.value.answerText;
    case 'help-app:open':
    case 'help-app:search':
    case 'help-app:app':
    case 'help-app:request':
      return null;
    default:
      return 'secondary';
  }
}

export default ContextEvent;
